import generatedReleaseNotes, { generatedAppVersion } from './releaseNotes.generated';

export type ReleaseNote = {
  version: string;
  date: string;
  commit?: string;
  repository?: string;
  title: string;
  category: 'Infra' | 'Backend' | 'Frontend' | 'IA' | 'Seguranca';
  description: string;
};

export const appVersion = process.env.REACT_APP_VERSION || generatedAppVersion || '0.1.0';
export const buildCommit = process.env.REACT_APP_COMMIT_SHA || process.env.REACT_APP_GIT_SHA || 'local';

const manualReleaseNotes: ReleaseNote[] = [
  {
    version: appVersion,
    date: '2026-07-03',
    commit: '95ed6c2',
    title: 'Scheduler diário de aprendizado habilitado',
    category: 'Infra',
    description: 'O job diário de feedback da IA passa a ficar habilitado por padrão no EventBridge Scheduler.'
  },
  {
    version: appVersion,
    date: '2026-07-03',
    commit: '3b58989',
    title: 'Insights AWS enriquecidos',
    category: 'Backend',
    description: 'Relatórios AWS passaram a salvar top serviços, nomes de contas e detalhes de segurança com recursos afetados.'
  },
  {
    version: appVersion,
    date: '2026-07-03',
    commit: 'b255f02',
    title: 'Dashboard executivo mais legível',
    category: 'Frontend',
    description: 'Cards de IA, causa raiz, anomalias e oportunidades receberam ajustes de leitura e organização visual.'
  }
];

const normalizedGeneratedReleaseNotes = (generatedReleaseNotes as ReleaseNote[]).map((note) => ({
  ...note,
  version: appVersion
}));

export const releaseNotes: ReleaseNote[] = normalizedGeneratedReleaseNotes.length
  ? normalizedGeneratedReleaseNotes
  : manualReleaseNotes;
